var App = App || {};

App.Masthead = (function ($) {
    'use strict';

    function HomePromoIcons() {
        $(".masthead.home .masthead-promo-bands").each(function () {
            const carousel = $(this).children(".splide");
            var splide = new Splide(carousel[0], {
                type: "loop",
                arrows: false,
                label: "Masthead promo band carousel",
                autoplay: true,
                interval: 7500,
                pauseOnHover: true,
                pauseOnFocus: true
            });
            splide.mount();
        });
    }

    function HomePromoCards() {

        const masthead = $(".masthead.home");
        const group = masthead.next(".component-folder").children(".component-group").first();
        const groupTheme = group.attr("data-bs-theme");
        const themes = ["abyss", "fountain"];

        if (masthead.find(".masthead-promo-cards").length > 0 && themes.includes(groupTheme)) {
            masthead.addClass("has-masthead-cards");
            group.addClass("accommodate-masthead-cards");
        }

    }

    return {
        HomePromoIcons: HomePromoIcons,
        HomePromoCards: HomePromoCards
    };

})(jQuery);

$(function () {
    App.Masthead.HomePromoIcons();
    App.Masthead.HomePromoCards();
});